import { BaseModel } from "../../../../../../core/_base/crud";
import { Time } from "@angular/common";
export class SettingDHM extends BaseModel {
	static sortDirection = "desc";
	static sortProperty = "NGAYLAPPHIEU";
	static category_path = "DHM";
	static optionsTrangThai = [
		{
			Position: 1,
			Code: "DHM_DANGSOANTHAO",
			Value: "Đang soạn thảo",
			Show: true,
		},
		{
			Position: 2,
			Code: "DHM_CHOTPDUYET",
			Value: "Chờ trưởng phòng duyệt",
			Show: true,
		},
		{
			Position: 3,
			Code: "DHM_HOANTAT",
			Value: "Hoàn tất",
			Show: true,
		},
		{
			Position: 4,
			Code: "DHM_DAHUY",
			Value: "Đã huỷ",
			Show: true,
		},
		{
			Position: 5,
			Code: "DHM_CHOGDKDUYET",
			Value: "Chờ GĐK duyệt",
			Show: true,
		},
		{
			Position: 6,
			Code: "DHM_CHOGDDUYET",
			Value: "Chờ GĐ duyệt",
			Show: true,
		},
		{
			Position: 7,
			Code: "DHM_CHODONGPO",
			Value: "Chờ đóng PO",
			Show: true,
		},
	];

	static optionsHinhThucThanhToan = [
		{
			Position: 1,
			Code: "01_TM",
			Name: "Tiền mặt",
			Default: true,
		},
		{
			Position: 2,
			Code: "02_CK",
			Name: "Chuyển khoản",
			Default: false,
		},
	];

	static optionsPhuongThucThanhToan = [
		{
			Position: 1,
			Code: "01_TT",
			Name: "Trả trước",
			Default: true,
		},
		{
			Position: 2,
			Code: "02_TS",
			Name: "Trả sau",
			Default: false,
		},
	];

	static optionsLoaiPhieu = [
		{
			Position: 1,
			Code: "0",
			Name: "Mua hàng đề nghị",
			Default: true,
		},
		{
			Position: 2,
			Code: "1",
			Name: "Mua hàng định mức tồn kho",
			Default: false,
		},
	];

	static optionsPhanTramThue = [
		{
			Position: 1,
			Code: 0,
			Name: "Không thuế",
			Value: 0,
			Default: true,
		},
		{
			Position: 2,
			Code: 1,
			Name: "0",
			Value: 0,
			Default: false,
		},
		{
			Position: 3,
			Code: 2,
			Name: "5",
			Value: 5,
			Default: false,
		},
		{
			Position: 4,
			Code: 3,
			Name: "10",
			Value: 10,
			Default: false,
		},
	];

	static optionsRoles = [{}];
}

export class LichSuGiaoHang extends BaseModel {
	SLNhapKho: number;
	SLHangVe: number;
	DVT: string;
	NgayGioVaoCong: string;
	SoPhieuTTHV: string;
	NgayLapPhieu: string;

	clear() {
		this.SLNhapKho = 0;
		this.DVT = "";
		this.NgayGioVaoCong = "";
		this.SoPhieuTTHV = "";
		this.NgayLapPhieu = "";
		this.SLHangVe = 0;
	}

	copy(item: LichSuGiaoHang) {
		this.SLNhapKho = item.SLNhapKho;
		this.DVT = item.DVT;
		this.NgayGioVaoCong = item.NgayGioVaoCong;
		this.SoPhieuTTHV = item.SoPhieuTTHV;
		this.NgayLapPhieu = item.NgayLapPhieu;
		this.SLHangVe = item.SLHangVe;
	}
}

export class DonHangMua extends BaseModel {
	Id: number;
	SoPhieu: string;
	ThoiGianTao: string;
	NguoiTao: number;
	TenNguoiTao: string;
	TinhTrang_Code: string;
	TinhTrang_Name: string;
	NgayDat: string;
	IdNCC: number;
	MaNCC: string;
	TenNCC: string;
	NguoiLienHe: string;
	DienThoai: string;
	DiaChi: string;
	PayMents: string;
	HinhThucThanhToan_Ten: string;
	IdHD: number;
	MaHD: string;
	TenHD: string;
	DiaDiemGiaoHang: string;
	DieuKienGiaoHang: string;
	DonVi_Id: number;
	DonVi_Ten: string;
	TyGia: number;
	TongTienPhaiTra: number;
	Id_TPDuyet: number;
	Name_TPDuyet: string;
	Date_TPDuyet: string;
	LyDo_TPDuyet: string;
	Id_GDKDuyet: number;
	Name_GDKDuyet: string;
	Date_GDKDuyet: string;
	LyDo_GDKDuyet: string;
	Id_GDKTMDuyet: number;
	Name_GDKTMDuyet: string;
	Date_GDKTMDuyet: string;
	LyDo_GDKTMDuyet: string;
	Id_GDDuyet: number;
	Name_GDDuyet: string;
	Date_GDDuyet: string;
	LyDo_GDDuyet: string;
	IsEnable_Duyet: boolean;
	IsVisible_Duyet: boolean;
	IsCoHoaDon: boolean;
	IsTraTruoc: boolean;
	TyLeTraTruoc: number;
	ThoiHanTraSau: number;
	BangChungNCC: number;
	TongTienChuaThue: number;
	TongTienThue: number;
	SoHD: string;
	ChiTiet: DonHangMuaChiTiet[] = [];
	listFileDinhKem: FileImport[];
	listFileBangChung: FileImport[];
	IsMuaTheoDeNghi: boolean;
	SoPhieuDNMH: string;
	PaymentOptions: PaymentOptions[];
	GhiChu: string;
	Contract: string;
	ContractLink: string;
	TypeOfProduct: number;
  ExistsHistory: boolean;
  IsSelectedApprovalPermission: boolean;
  InvoiceNo: string;
	clear() {
		this.Id = 0;
		this.SoPhieu = "";
		this.ThoiGianTao = "";
		this.NguoiTao = 0;
		this.TenNguoiTao = "";
		this.TinhTrang_Code = "";
		this.TinhTrang_Name = "";
		this.NgayDat = "";
		this.IdNCC = 0;
		this.MaNCC = "";
		this.TenNCC = "";
		this.NguoiLienHe = "";
		this.DienThoai = "";
		this.DiaChi = "";
		this.PayMents = "";
		this.HinhThucThanhToan_Ten = "";
		this.IdHD = 0;
		this.MaHD = "";
		this.TenHD = "";
		this.DiaDiemGiaoHang = "";
		this.DieuKienGiaoHang = "";
		this.DonVi_Id = 0;
		this.DonVi_Ten = "";
		this.TyGia = 0;
		this.TongTienPhaiTra = 0;
		this.Id_TPDuyet = 0;
		this.Name_TPDuyet = "";
		this.Date_TPDuyet = "";
		this.LyDo_TPDuyet = "";
		this.Id_GDKDuyet = 0;
		this.Name_GDKDuyet = "";
		this.Date_GDKDuyet = "";
		this.LyDo_GDKDuyet = "";
		this.Id_GDDuyet = 0;
		this.Name_GDDuyet = "";
		this.Date_GDDuyet = "";
		this.LyDo_GDDuyet = "";
		this.IsEnable_Duyet = false;
		this.IsVisible_Duyet = false;
		this.IsCoHoaDon = false;
		this.IsTraTruoc = true;
		this.TyLeTraTruoc = 0;
		this.ThoiHanTraSau = 0;
		this.BangChungNCC = 0;
		this.TongTienChuaThue = 0;
		this.TongTienThue = 0;
		this.SoHD = "";
		this.ChiTiet = [];
		this.IsMuaTheoDeNghi = false;
		this.listFileDinhKem = [];
		this.listFileBangChung = [];
		this.SoPhieuDNMH = "";
		this.Id_GDKTMDuyet = 0;
		this.Name_GDKTMDuyet = "";
		this.Date_GDKTMDuyet = "";
		this.LyDo_GDKTMDuyet = "";
		this.PaymentOptions = [];
		this.GhiChu = "";
		this.Contract = "";
		this.ContractLink = "";
		this.TypeOfProduct = null;
    this.ExistsHistory = false;
    this.IsSelectedApprovalPermission = false;
    this.InvoiceNo = null;
	}

	copy(item: DonHangMua) {
		this.Id = item.Id;
		this.SoPhieu = item.SoPhieu;
		this.ThoiGianTao = item.ThoiGianTao;
		this.NguoiTao = item.NguoiTao;
		this.TenNguoiTao = item.TenNguoiTao;
		this.TinhTrang_Code = item.TinhTrang_Code;
		this.TinhTrang_Name = item.TinhTrang_Name;
		this.NgayDat = item.NgayDat;
		this.IdNCC = item.IdNCC;
		this.MaNCC = item.MaNCC;
		this.TenNCC = item.TenNCC;
		this.NguoiLienHe = item.NguoiLienHe;
		this.DienThoai = item.DienThoai;
		this.DiaChi = item.DiaChi;
		this.PayMents = item.PayMents;
		this.HinhThucThanhToan_Ten = item.HinhThucThanhToan_Ten;
		this.IdHD = item.IdHD;
		this.MaHD = item.MaHD;
		this.TenHD = item.TenHD;
		this.DiaDiemGiaoHang = item.DiaDiemGiaoHang;
		this.DieuKienGiaoHang = item.DieuKienGiaoHang;
		this.DonVi_Id = item.DonVi_Id;
		this.DonVi_Ten = item.DonVi_Ten;
		this.TyGia = item.TyGia;
		this.TongTienPhaiTra = item.TongTienPhaiTra;
		this.Id_TPDuyet = item.Id_TPDuyet;
		this.Name_TPDuyet = item.Name_TPDuyet;
		this.Date_TPDuyet = item.Date_TPDuyet;
		this.LyDo_TPDuyet = item.LyDo_TPDuyet;
		this.Id_GDKDuyet = item.Id_GDKDuyet;
		this.Name_GDKDuyet = item.Name_GDKDuyet;
		this.Date_GDKDuyet = item.Date_GDKDuyet;
		this.LyDo_GDKDuyet = item.LyDo_GDKDuyet;
		this.Id_GDDuyet = item.Id_GDDuyet;
		this.Name_GDDuyet = item.Name_GDDuyet;
		this.Date_GDDuyet = item.Date_GDDuyet;
		this.LyDo_GDDuyet = item.LyDo_GDDuyet;
		this.IsEnable_Duyet = item.IsEnable_Duyet;
		this.IsVisible_Duyet = item.IsVisible_Duyet;
		this.IsCoHoaDon = item.IsCoHoaDon;
		this.IsTraTruoc = item.IsTraTruoc;
		this.TyLeTraTruoc = item.TyLeTraTruoc;
		this.ThoiHanTraSau = item.ThoiHanTraSau;
		this.BangChungNCC = item.BangChungNCC;
		this.TongTienChuaThue = item.TongTienChuaThue;
		this.TongTienThue = item.TongTienThue;
		this.SoHD = item.SoHD;
		this.ChiTiet = item.ChiTiet;
		this.IsMuaTheoDeNghi = item.IsMuaTheoDeNghi;
		this.listFileDinhKem = item.listFileDinhKem;
		this.listFileBangChung = item.listFileBangChung;
		this.SoPhieuDNMH = item.SoPhieuDNMH;
		this.Id_GDKTMDuyet = item.Id_GDKTMDuyet;
		this.Name_GDKTMDuyet = item.Name_GDKTMDuyet;
		this.Date_GDKTMDuyet = item.Date_GDKTMDuyet;
		this.LyDo_GDKTMDuyet = item.LyDo_GDKTMDuyet;
		this.PaymentOptions = item.PaymentOptions;
		this.GhiChu = item.GhiChu;
		this.Contract = item.Contract;
		this.ContractLink = item.ContractLink;
		this.TypeOfProduct = item.TypeOfProduct;
    this.ExistsHistory = item.ExistsHistory;
    this.IsSelectedApprovalPermission = item.IsSelectedApprovalPermission;
    this.InvoiceNo = item.InvoiceNo;
	}
}

export class DonHangMuaChiTiet extends BaseModel {
	Id: number;
	IdPhieu: number;
	IdHH: number;
	MaHH: string;
	TenHH: string;
	IdDVT: number;
	TenDVT: string;
	SoLuong: number;
	DonGia: number;
	ThanhTien: number;
	ThanhTienQuyDoi: number;
	GhiChu: string;
	IdDNMH: number;
	SoPhieuDNMH: string;
	QuyCach: string;
	IdNCC: number;
	DonVi_Ten: string;
	DonVi_Id: number;
	TyGia: number;
	isCreatePO: boolean;
	SoLuongHangVe: number;
	SoLuongDaGiao: number;
	PhieuDeNghi_Id_Ct: number;
	PhanTramThue: number;
	TienThue: number;
	QuyetDinhDuyetPO: string;
	KeHoachNCCGiaoHang: KeHoachNCCGiaoHang[];
	GiaDuKien: number;
	SoLuongDeNghi: number;
	QuyetDinhDuyetPOColor: string;
	PhanTramDungSaiGia: number;
	TrangThaiMH: number;
	PhongBanSuDung: string;
	PhongBanSuDung_Id: number;
	IsEnable_TPDuyet: boolean;
	IsEnable_GDKDuyet: boolean;
	IsEnable_GDDuyet: boolean;
	IsEnable_GDKTMDuyet: boolean;
	HanMucDuyet: number;
	HanMucPhongBan: number;
	HanMucPhongBanNhuCau: number;
	IsOverHanMucPhongBan: boolean;
	IsCoKeHoach: boolean;
	IsHaveInHD: boolean;
	IsOverSLConLaiHD: boolean;
	RecordSumAmount: boolean;
	FileTieuChuan: string;
	NgayDeNghiGiaoHang: string;
	Reason: string;
	flagAccept: boolean;
	clear() {
		this.Id = 0;
		this.IdPhieu = 0;
		this.IdHH = 0;
		this.MaHH = "";
		this.TenHH = "";
		this.IdDVT = 0;
		this.TenDVT = "";
		this.SoLuong = 0;
		this.DonGia = 0;
		this.ThanhTien = 0;
		this.ThanhTienQuyDoi = 0;
		this.GhiChu = "";
		this.IdDNMH = 0;
		this.SoPhieuDNMH;
		this.QuyCach = "";
		this.IdNCC = -1;
		this.DonVi_Ten = "";
		this.DonVi_Id = 0;
		this.TyGia = 0;
		this.isCreatePO = false;
		this.SoLuongHangVe = 0;
		this.SoLuongDaGiao = 0;
		this.PhieuDeNghi_Id_Ct = 0;
		this.PhanTramThue = 0;
		this.TienThue = 0;
		this.QuyetDinhDuyetPO = "";
		this.KeHoachNCCGiaoHang = [];
		this.GiaDuKien = 0;
		this.QuyetDinhDuyetPOColor = "";
		this.PhanTramDungSaiGia = 0;
		this.TrangThaiMH = 0;
		this.PhongBanSuDung = "";
		this.PhongBanSuDung_Id = 0;
		this.SoLuongDeNghi = 0;
		this.IsEnable_TPDuyet = false;
		this.IsEnable_GDKDuyet = false;
		this.IsEnable_GDKTMDuyet = false;
		this.IsEnable_GDDuyet = false;
		this.HanMucDuyet = 0;
		this.HanMucPhongBan = 0;
		this.HanMucPhongBanNhuCau = 0;
		this.IsOverHanMucPhongBan = false;
		this.IsCoKeHoach = true;
		this.IsHaveInHD = true;
		this.IsOverSLConLaiHD = false;
		this.RecordSumAmount = false;
		this.FileTieuChuan = "";
		this.NgayDeNghiGiaoHang = "";
		this.Reason = "";
		this.flagAccept = true;
	}

	copy(item: DonHangMuaChiTiet) {
		this.Id = item.Id;
		this.IdPhieu = item.IdPhieu;
		this.IdHH = item.IdHH;
		this.MaHH = item.MaHH;
		this.TenHH = item.TenHH;
		this.IdDVT = item.IdDVT;
		this.TenDVT = item.TenDVT;
		this.SoLuong = item.SoLuong;
		this.DonGia = item.DonGia;
		this.ThanhTien = item.ThanhTien;
		this.ThanhTienQuyDoi = item.ThanhTienQuyDoi;
		this.GhiChu = item.GhiChu;
		this.IdDNMH = item.IdDNMH;
		this.SoPhieuDNMH = item.SoPhieuDNMH;
		this.QuyCach = item.QuyCach;
		this.IdNCC = item.IdNCC;
		this.DonVi_Ten = item.DonVi_Ten;
		this.DonVi_Id = item.DonVi_Id;
		this.TyGia = item.TyGia;
		this.isCreatePO = item.isCreatePO;
		this.SoLuongHangVe = item.SoLuongHangVe;
		this.SoLuongDaGiao = item.SoLuongDaGiao;
		this.PhieuDeNghi_Id_Ct = item.PhieuDeNghi_Id_Ct;
		this.PhanTramThue = item.PhanTramThue;
		this.TienThue = item.TienThue;
		this.QuyetDinhDuyetPO = item.QuyetDinhDuyetPO;
		this.KeHoachNCCGiaoHang = item.KeHoachNCCGiaoHang;
		this.GiaDuKien = item.GiaDuKien;
		this.QuyetDinhDuyetPOColor = item.QuyetDinhDuyetPOColor;
		this.PhanTramDungSaiGia = item.PhanTramDungSaiGia;
		this.TrangThaiMH = item.TrangThaiMH;
		this.PhongBanSuDung = item.PhongBanSuDung;
		this.PhongBanSuDung_Id = item.PhongBanSuDung_Id;
		this.SoLuongDeNghi = item.SoLuongDeNghi;
		this.IsEnable_TPDuyet = item.IsEnable_TPDuyet;
		this.IsEnable_GDKDuyet = item.IsEnable_GDKDuyet;
		this.IsEnable_GDKTMDuyet = item.IsEnable_GDKTMDuyet;
		this.IsEnable_GDDuyet = item.IsEnable_GDDuyet;
		this.HanMucDuyet = item.HanMucDuyet;
		this.HanMucPhongBan = item.HanMucPhongBan;
		this.HanMucPhongBanNhuCau = item.HanMucPhongBanNhuCau;
		this.IsOverHanMucPhongBan = item.IsOverHanMucPhongBan;
		this.IsCoKeHoach = item.IsCoKeHoach;
		this.IsHaveInHD = item.IsHaveInHD;
		this.IsOverSLConLaiHD = item.IsOverSLConLaiHD;
		this.RecordSumAmount = item.RecordSumAmount;
		this.FileTieuChuan = item.FileTieuChuan;
		this.NgayDeNghiGiaoHang = item.NgayDeNghiGiaoHang;
		this.Reason = item.Reason;
		this.flagAccept = item.flagAccept;
	}
}

export class DonHangMuaHistory extends BaseModel {
	MaNCC: string;
	TenNCC: string;
	SoLuong: number;
	DVT: string;
	SoPhieuDHM: string;
	NgayDatHang: string;
	DonGia: number;
	LoaiTien: string;

	clear() {
		this.MaNCC = "";
		this.TenNCC = "";
		this.SoLuong = 0;
		this.DVT = "";
		this.SoPhieuDHM = "";
		this.NgayDatHang = "";
		this.DonGia = 0;
		this.LoaiTien = "";
	}

	copy(item: DonHangMuaHistory) {
		this.MaNCC = item.MaNCC;
		this.TenNCC = item.TenNCC;
		this.SoLuong = item.SoLuong;
		this.DVT = item.DVT;
		this.SoPhieuDHM = item.SoPhieuDHM;
		this.NgayDatHang = item.NgayDatHang;
		this.DonGia = item.DonGia;
		this.LoaiTien = item.LoaiTien;
	}
}

export class KeHoachNCCGiaoHang {
	HangHoa_Id: number;
	SoLuong: number;
	NgayVe: string;
	DoiTuong_Id: number;
	DoiTuong_Loai = 2;
	NguonPhatSinh_Id: number;
	NguonPhatSinh_Loai: string;
	IsDisable: boolean;
	GioVe: string;
	GioDen: string;
	DVT: number;
	DaNhapHang: boolean;
	TrangThai: string;

	clear() {
		this.HangHoa_Id = 0;
		this.SoLuong = 0;
		this.NgayVe = "";
		this.DoiTuong_Id = 0;
		this.DoiTuong_Loai = 2;
		this.NguonPhatSinh_Id = 0;
		this.NguonPhatSinh_Loai = "NPSLPTTHV_MUAHANG";
		this.IsDisable = true;
		this.GioVe = "";
		this.GioDen = "";
		this.DVT = 0;
		this.DaNhapHang = false;
		this.TrangThai = "";
	}
}

export class FileImport extends BaseModel {
	idLoaiHH: number;
	base64: string;
	fileByte: any;
	filename: string;
	dienGiai: string;
	extension: string;

	clear() {
		this.idLoaiHH = 0;
		this.base64 = "";
		this.fileByte = null;
		this.filename = "";
		this.dienGiai = "";
		this.extension = "";
	}

	copy(item: FileImport) {
		this.idLoaiHH = item.idLoaiHH;
		this.base64 = item.base64;
		this.fileByte = item.fileByte;
		this.filename = item.filename;
		this.dienGiai = item.dienGiai;
		this.extension = item.extension;
	}
}

export class ListFileModel {
	name: string;
	id: number;
	description: string;
	data: FileImport;
	file: any;
}

export class PaymentOptions {
	per_payment: number;
	number_date: number;
	type_of_payment: number;
	description: string;
	clear() {
		this.per_payment = 0;
		this.number_date = 0;
		this.type_of_payment = 0;
		this.description = "";
	}
	copy(item: PaymentOptions) {
		this.per_payment = item.per_payment;
		this.number_date = item.number_date;
		this.type_of_payment = item.type_of_payment;
		this.description = item.description;
	}
}

export class HistoryLogBodyDto {
  productCode: string
  productName: string
  quantityBeforeChange: number
  quantityAfterChange: number
  priceBeforeChange: number
  priceAfterChange: number
  createdBy: string
  createdTime: string
  description: string
}
